import type { ExpressionOperatorRegistry } from './ExpressionOperatorRegistry.ts';
import { z } from 'zod';
import {
  ALLOWED_OPERATORS,
  CONDITIONAL_SYNTAX,
  SAFE_CONSTANTS,
} from './expressionLanguage.ts';
import {
  expressionOperatorDescriptorSchema,

} from './ExpressionOperatorRegistry.ts';

export const expressionCapabilitiesSchema = z.object({
  schemaVersion: z.literal(1),
  operators: z.array(z.string()),
  constants: z.array(z.string()),
  conditionalSyntax: z.literal('ternary'),
  functions: z.array(expressionOperatorDescriptorSchema),
}).strict();

export type ExpressionCapabilities = z.infer<
  typeof expressionCapabilitiesSchema
>;

/**
 * Serialize the language surface from the same facts that SafeExpressionEngine
 * enforces at runtime. This descriptor is a capability declaration, never an
 * instruction stream: the backend must only use it to validate/generate, and
 * must never execute function names it does not already trust.
 */
export function serializeExpressionCapabilities(
  registry: ExpressionOperatorRegistry,
): ExpressionCapabilities {
  return expressionCapabilitiesSchema.parse({
    schemaVersion: 1,
    operators: [...ALLOWED_OPERATORS],
    constants: [...SAFE_CONSTANTS],
    conditionalSyntax: CONDITIONAL_SYNTAX,
    functions: registry.listDescriptors(),
  });
}
